import React, { useEffect, useState } from 'react';
import Popup from 'reactjs-popup';
import api from '../../api';
import { toast } from 'react-toastify';
import { Button, Input, Select } from '../Common';

const priceAreas = [
    { value: '', label: 'Price Area', hidden: true },
    { value: 'AT', label: 'AT' },
    { value: 'GER', label: 'GER' },
    { value: 'SE1', label: 'SE1' },
    { value: 'SE2', label: 'SE2' },
    { value: 'SE3', label: 'SE3' },
    { value: 'SE4', label: 'SE4' },
];

const TOAST_OPTIONS = {
    position: 'top-center',
    autoClose: 300,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};

const EditFacilityModal = ({ facility, open, setOpen, onSuccess }) => {
    const [address, setAddress] = useState(facility?.address || '');
    const [priceArea, setPriceArea] = useState(facility?.price_area || '');
    const [error, setError] = useState('');

    useEffect(() => {
        setAddress(facility?.address || '');
        setPriceArea(facility?.price_area || '');
    }, [facility]);

    const updateFacility = async () => {
        setError('');
        try {
            await api.patch_facility(facility.facility_id, { address, price_area: priceArea });
            toast.success('Facility updated successfully', TOAST_OPTIONS);
            onSuccess();
        } catch (err) {
            console.error(err);
            setError('An error occurred while updating the facility. Please try again.');
        }
    };

    const handleClose = () => {
        setAddress(facility?.address || '');
        setPriceArea(facility?.price_area || '');
        setError('');
        setOpen(false);
    };

    return (
        <Popup open={open} onClose={handleClose} modal className="modal">
            <div>
                <button className="modal__close" onClick={handleClose}>
                    &#10005;
                </button>
                <h5 className="modal__header">Edit Facility</h5>
                <div className="modal__content customer-details__edit-facility-content">
                    <Input
                        id="facilityAddress"
                        type="text"
                        placeholder="Address"
                        value={address}
                        onChange={e => setAddress(e.target.value)}
                        fullWidth
                    />
                    <Select id="facilityPriceArea" value={priceArea} onChange={e => setPriceArea(e.target.value)} options={priceAreas} fullWidth />

                    {error && <p className="create-facility__error-message">{error}</p>}
                </div>
                <div className="modal__actions">
                    <Button text="Save" onClick={updateFacility} />
                    <Button text="Cancel" onClick={handleClose} className="modal__cancel" />
                </div>
            </div>
        </Popup>
    );
};

export default EditFacilityModal;
